export default __webpack_public_path__ + "static/media/nft10.0066b4ab.png";